import React from "react";

const STAT_TILES = [0, 1, 2, 3];
const FILTER_CHIPS = [0, 1, 2, 3, 4];
const CARD_ROWS = [0, 1, 2];

/** One placeholder card, shaped like a consultation row. */
export const ConsultationCardSkeleton: React.FC = () => (
  <div className="cs-item cs-item-skeleton">
    <div className="cs-when">
      <div className="cs-sk cs-sk-day" />
      <div className="cs-sk cs-sk-mon" />
    </div>
    <div className="cs-main">
      <div className="cs-sk-top">
        <div className="cs-sk cs-sk-coach" />
        <div className="cs-sk cs-sk-tag" />
        <div className="cs-sk cs-sk-tag" />
      </div>
      <div className="cs-sk cs-sk-meta" />
      <div className="cs-sk cs-sk-notes" />
    </div>
  </div>
);

/** A couple of cards, for the page appended while scrolling. */
export const ConsultationsPageSkeleton: React.FC = () => (
  <div className="cs-list cs-list-more">
    <ConsultationCardSkeleton />
    <ConsultationCardSkeleton />
  </div>
);

/**
 * Stands in for the whole screen on first load, shaped like what replaces it —
 * four stat tiles, the filter row and a few consultation cards — so the layout
 * does not jump once the payload lands.
 */
const ConsultationsSkeleton: React.FC = () => (
  <>
    <div className="cs-stats">
      {STAT_TILES.map((tile) => (
        <div className="cs-stat cs-stat-skeleton" key={tile}>
          <div className="cs-sk cs-sk-label" />
          <div className="cs-sk cs-sk-value" />
        </div>
      ))}
    </div>

    <div className="cs-toolbar">
      <div className="cs-filters">
        {FILTER_CHIPS.map((chip) => (
          <div className="cs-sk cs-sk-chip" key={chip} />
        ))}
      </div>
      <div className="cs-sk cs-sk-btn" />
    </div>

    <div className="cs-list">
      {CARD_ROWS.map((row) => (
        <ConsultationCardSkeleton key={row} />
      ))}
    </div>
  </>
);

export default ConsultationsSkeleton;
